<div class="wrapper">
  <div class="container px-0">
    <div class=" pb-2 fw-bold">
      <h5 class="title fw-bold text-center mb-2 mt-2 fw-bold">{{'checkinpayment.title' | translate}}</h5>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-12">
        <div [ngClass]="{'card border': !((isCopay && !isoutstanding) || (isoutstanding && !isCopay)) }">
          <div class="card-body p-0 ">
            <div [ngClass]="{'mycontainer': !((isCopay && !isoutstanding) || (isoutstanding && !isCopay)) }">
              <div *ngIf="isCopay" class="box"
                   [ngClass]="{'selected': selectedBox === 'box2'}"
                   (click)="selectBox('box2')">
                <span>{{'checkinpayment.copayforvisit'|translate}}  <br> <b>${{paymentDetials.data.currentDayAmount! | number : '.2-2'}}</b></span>
                <i *ngIf="selectedBox === 'box2'" class="fas fa-check-circle check-icon"></i>
              </div>

              <div *ngIf="isoutstanding" class="box"
                   [ngClass]="{'selected': selectedBox === 'box1'}"
                   (click)="selectBox('box1')">
                <span>{{'checkinpayment.outbalance'|translate}} <br><b><span [ngStyle]="{'color': isMinuDueAmount != 'false' ? 'red':''}"><span *ngIf="isMinuDueAmount != 'false'">(</span>${{isMinuDueAmount != 'false' ? isMinuDueAmount : paymentDetials.data.amT_DUE | number : '.2-2'}}<span *ngIf="isMinuDueAmount != 'false'">)</span></span></b></span>
                <i *ngIf="selectedBox === 'box1'" class="fas fa-check-circle check-icon"></i>
              </div>

              <div *ngIf="isCopay && isoutstanding" class="box"
                   [ngClass]="{'selected': selectedBox === 'box3'}"
                   (click)="selectBox('box3')">
                <span>{{'checkinpayment.outstading'|translate}}  + {{'checkinpayment.copay'|translate}} <br><b><span [ngStyle]="{'color': isMinuTotalAmount != 'false' ? 'red':''}"><span *ngIf="isMinuTotalAmount != 'false'">(</span>${{isMinuTotalAmount != 'false' ? isMinuTotalAmount : paymentDetials.data.totalAmount | number : '.2-2'}}<span *ngIf="isMinuTotalAmount != 'false'">)</span></span></b></span>
                <i *ngIf="selectedBox === 'box3'" class="fas fa-check-circle check-icon"></i>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ShowAmountField" class="devider mb-4">
          <span>{{'insurances.insurance_or' | translate}}</span>
        </div>

      </div>


      <form [formGroup]="paymentForm">
        <div *ngIf="ShowAmountField" class="col-md-12">
          <div class="form-group ">
            <div class="border-bottom mb-2">
              <label class="fw-bold">{{'checkinpayment.amount_label'|translate}} </label>
              <div class="ltr-component">
                <i _ngcontent-pqg-c5="" class="fa fa-dollar-sign form-control-feedback"></i>
                <!--<input type="text" class="form-control border-0" style="padding-left: 20px !important;" [(ngModel)]="amount" placeholder="{{'checkinpayment.amount_placeholder'|translate}}" (keypress)="validateCurreny($event)">-->
                <input formControlName="amount" maxlength="7"
                       (keypress)="validateCurreny($event)" (input)="checkAmountInput($event)"
                       type="text" inputmode="numeric" class="form-control border-0" style="padding-left: 20px !important;" placeholder="{{'checkinpayment.amount_placeholder'|translate}}">
              </div>
            </div>
            <span *ngIf="isoutstanding && !isCopay">
              <span *ngIf="getpaymentForm?.amount?.invalid && getpaymentForm?.amount?.touched">
                <span *ngIf="getpaymentForm?.amount?.errors!.required" class="text-danger">{{'checkinpayment.amount_required'|translate}}</span>
              </span>
            </span>

            <span *ngIf="(+this.paymentForm?.controls?.['amount']?.value > amountDueTemp) && (+this.paymentForm?.controls?.['amount']?.value <= 4999)"
                  class="text-danger err">
              {{'paymentPage.paymenShouldNotGreaterThanTotal' | translate}}
            </span>
            <span *ngIf="!isMinAmount" class="text-danger err">
              {{'checkinpayment.enter_minimum_copay'|translate}}
            </span>
            <span *ngIf="+this.paymentForm?.controls?.['amount']?.value>4999" class="text-danger err">{{'paymentPage.paymenIsExceedingLimit' |translate}} $4999.00.</span>
          </div>
        </div>
      </form>

      <div class="col-md-12 mb-3 text-center">
        <button class="btn btn-primary btncare mt-1" type="button" (click)="onClickNext()">{{'button.payNow'|translate}}</button>
      </div>
      <div *ngIf="payLaterButton" class="col-md-12 mb-3 text-center">
        <button class="btn btn-outline-primary btncare mt-1" type="button" (click)="onFinishIntake()">{{'paymentOverView.payLater'|translate}} </button>
      </div>
    </div>

    <!--<div *ngIf="showMessage" class="card" style="background-color: #E0F2F1;">
      <div class="card-body">
        <h5> {{'checkinpayment.alredyCheckinInfo'|translate}}</h5>
      </div>
    </div>-->


  </div>
</div>

<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <a [ngStyle]="{'display': hidebackButton ? 'none':'inline-block'}" class="btn btn-outline-primary" type="button" href="javascript:void(0)" (click)="onClickBack()">{{'button.back'|translate}}</a>
      <a class="btn btn-primary" type="button" (click)="onClickNext()" style="float:right;">{{'button.payNow'|translate}} </a>
    </div>
  </div>
</footer>
